// user-contact-icons.tsx
// Three small icons on the line of a recipient : e-mail, phone, postal address.
// Colours of the charter (classes green-t, medgrey-t, orange-t) : green when filled, light grey when missing and not needed by the modes
// of the project (looks disabled), orange when missing on a channel in use. No red here : the gravity is told by the alerts of the step,
// the line only shows what is filled.
import { faEnvelope, faMapMarkerAlt, faMobileAlt } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { useTranslation } from "react-i18next"
import Tooltip from "@/components/tooltip"
import { getContactStates } from "@/utils/recipient-reach.utils"

interface OwnProps {
  user: any
  diffusionMode: { email?: boolean; sms?: boolean; qrcode?: boolean } | null | undefined
  qrcodeOptions: { hideAddress?: boolean } | null | undefined
}

const ICONS = { email: faEnvelope, phone: faMobileAlt, address: faMapMarkerAlt }
const LABELS = { email: "user_email", phone: "user_phone", address: "user_address" }
const VALUES = { email: "email", phone: "phone", address: "address" }

export default function UserContactIcons(props: OwnProps) {
  const { t } = useTranslation()

  const states = getContactStates(props.user, props.diffusionMode, props.qrcodeOptions)

  return (
    <div className="flex items-center gap-3" style={{ marginRight: 24 }}>
      {states.map((state) => (
        <Tooltip
          key={state.contact}
          text={t(LABELS[state.contact]) + " : " + (state.present ? props.user[VALUES[state.contact]] : "-")}
          position="top"
          usePortal>
          <FontAwesomeIcon
            icon={ICONS[state.contact]}
            className={state.present ? "green-t" : state.required ? "orange-t" : "medgrey-t"}
            style={{ width: 14 }}
          />
        </Tooltip>
      ))}
    </div>
  )
}
